<div class="add">
  <div class="autocomplete">
    <ng-autocomplete
      [data]="sections"
      [searchKeyword]="'name'"
      placeholder="Search for sections"
      [itemTemplate]="itemTemplate"
      [notFoundTemplate]="notFoundTemplate"
      [formControl]="sectionControl"
    ></ng-autocomplete>
    <ng-template #itemTemplate let-item>
      <a [innerHTML]="item.name"></a>
    </ng-template>

    <ng-template #notFoundTemplate let-notFound>
      <div [innerHTML]="notFound"></div>
    </ng-template>
  </div>

  <div class="name-control">
    <input
      class="name"
      type="text"
      placeholder="Domain name"
      [ngClass]="{ hasError: !sectionDomainNameControl.valid }"
      [formControl]="sectionDomainNameControl"
    />
    <ng-container
      *ngIf="!sectionDomainNameControl.valid && sectionDomainNameControl.dirty"
    >
      <div
        *ngIf="sectionDomainNameControl.errors?.whitespace"
        class="name--hasError"
      >
        Domain should not contain spaces
      </div>
    </ng-container>
  </div>
  <button
    type="button"
    (click)="addSection()"
    [ngClass]="{
      disabled: !sectionControl.valid || !sectionDomainNameControl.valid
    }"
  >
    Add
  </button>
</div>

<div class="domains">
  <div class="domains-header">
    <div class="domains-item">Section</div>
    <div class="domains-item">Domain name</div>
    <div class="domains-item"></div>
  </div>
  <div
    *ngFor="let section of selectedSectionsDomains"
    class="domains-row"
    [ngClass]="{ selected: section.selected }"
    (click)="selectSection(section.id)"
  >
    <div class="domains-item">{{ section.name }}</div>
    <div class="domains-item">{{ section.domainName }}</div>
    <div class="domains-item">
      <div class="domains-actions">
        <div class="btn-group btn-group-sm" role="group" aria-label="actions">
          <button
            type="button"
            class="btn btn-group btn-group-sm btn-outline-primary btn-sm btn-block"
            (click)="
              actionClick({
                actionType: ActionType.Remove,
                payload: section.id
              })
            "
          >
            <i class="action-icon far fa-trash-alt"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
